import { Navigate } from "react-router";
import { useAuth } from "../auth/context";
import { SignUpPage } from "./SignUpPage";

export function SignUpConfirmationPage() {
  const { user, loading, error, access, accessRequested } = useAuth();
  if (!loading && !error && (!user || (access === "guest" && accessRequested === false))) {
    return <Navigate to="/sign-up" replace />;
  }
  return <SignUpPage />;
}
